<template>
  <div class="min-h-screen flex flex-col">
    <Navbar />
    <main class="flex-grow">
      <router-view />
    </main>
    <Footer />
    <VersionSelectorModal />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import VersionSelectorModal from '@/components/VersionSelectorModal.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    VersionSelectorModal
  }
}
</script> 